<script setup lang="ts">
// Two-tier pine — ported from the brand kit (foundations.jsx).
withDefaults(
  defineProps<{ size?: number; fill?: string; trunk?: string }>(),
  { size: 56, fill: 'currentColor', trunk: '#5b3724' },
)
</script>

<template>
  <svg :width="size" :height="size * 1.33" viewBox="0 0 60 80" aria-hidden="true">
    <rect x="26.5" y="62" width="7" height="16" :fill="trunk" />
    <path d="M30 4 L47 33 L37 33 L52 58 L8 58 L23 33 L13 33 Z" :fill="fill" />
  </svg>
</template>
